export default __webpack_public_path__ + "static/media/Search.4eb03f96.svg";